module.exports = __webpack_public_path__ + "img/package-x.8ff33111.svg";